
import React, { useState, useEffect, useMemo } from 'react';
import { useGetHigherLevelAnalysisMovementHistoryQuery } from '../../redux/slices/apiSlice';
import MIPriceMovementDataGraph from './MIPriceMovementDataGraph';
import { ColorRing } from 'react-loader-spinner';
import MISummaryCard from './MISummaryCard';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCaratRange, setSelectedCell, setSelectedClarities, setSelectedColors, setSelectedShape } from '../../redux/slices/miShapeCaratSlice';
import { skipToken } from '@reduxjs/toolkit/query';

const MIFourDropGraph = ({ accountDetails,selectedNeedsMetric, selectedLocation  }) => {

  // State for the four dropdown values
  // const [selectedShape, setSelectedShape] = useState("0000round");
  // const [selectedCaratRange, setSelectedCaratRange] = useState("1.0-1.49");
  // const [selectedColor, setSelectedColor] = useState("0003g");
  // const [selectedClarity, setSelectedClarity] = useState("0005vs2");
  const [diamondKeys, setDiamondKeys] = useState([]);

  const {selectedColor, selectedClarity, selectedCaratRange, selectedShape} = useSelector((state) => state.marketIntelligenceShapeCarat);
  // Configuration for all dropdown options
  const dispatch = useDispatch();
  const tabOptionsConfig = {
    "Shape": {
      prop_name: "shape",
      options: [
        { display: "Round", value: "0000round" },
        { display: "Princess", value: "0001princess" },
        { display: "Pear", value: "0002pear" },
        { display: "Oval", value: "0003oval" },
        { display: "Emerald", value: "0004emerald" },
        { display: "Marquise", value: "0005marquise" },
        { display: "Cushion", value: "0007cushion_brilliant" },
        { display: "Radiant", value: "0009radiant" },
        { display: "Asscher", value: "0011asscher" }
      ]
    },
    "Carat Range": {
      prop_name: "carats",
      options: [
        { display: "10.0-99.99", value: "10.0-99.99" },
        { display: "5.0-5.99", value: "5.0-5.99" },
        { display: "4.0-4.99", value: "4.0-4.99" },
        { display: "3.0-3.99", value: "3.0-3.99" },
        { display: "2.0-2.99", value: "2.0-2.99" },
        { display: "1.5-1.99", value: "1.5-1.99" },
        { display: "1.0-1.49", value: "1.0-1.49" },
        { display: "0.9-0.99", value: "0.9-0.99" },
        { display: "0.7-0.89", value: "0.7-0.89" },
        { display: "0.5-0.69", value: "0.5-0.69" },
        { display: "0.4-0.49", value: "0.4-0.49" },
        { display: "0.3-0.39", value: "0.3-0.39" },
        { display: "0.2-0.29", value: "0.2-0.29" },
        { display: "0-0.19", value: "0-0.19" },
      ]
    },
    "Color": {
      prop_name: "color",
      options: [
        { display: "D", value: "0000d" },
        { display: "E", value: "0001e" },
        { display: "F", value: "0002f" },
        { display: "G", value: "0003g" },
        { display: "H", value: "0004h" },
        { display: "I", value: "0005i" },
        { display: "J", value: "0006j" },
      ]
    },
    "Clarity": {
      prop_name: "clarity",
      options: [
        { display: "IF", value: "0001if" },
        { display: "VVS1", value: "0002vvs1" },
        { display: "VVS2", value: "0003vvs2" },
        { display: "VS1", value: "0004vs1" },
        { display: "VS2", value: "0005vs2" },
        { display: "SI1", value: "0006si1" },
        { display: "SI2", value: "0007si2" },
        { display: "I1", value: "0009i1" },
      ]
    },
  };

  // Build query parameters based on dropdown selections
  // const [queryParams, setQueryParams] = useState({
  //   id: accountDetails?.account_id || 'default-id',
  //   shape: selectedShape,
  //   carat_range: selectedCaratRange,
  //   color: selectedColor,
  //   clarity: selectedClarity,
  //   location: "0000round",
  //   duration_in_weeks: 4
  // });
  const isReady =
  accountDetails?.account_id &&
  selectedShape &&
  selectedCaratRange &&
  selectedColor &&
  selectedClarity &&
  selectedLocation &&
  selectedNeedsMetric;

  const queryParams = useMemo(() => isReady ? ({
  id: accountDetails.account_id,
  shape: selectedShape,
  carat_range: selectedCaratRange,
  color: selectedColor,
  clarity: selectedClarity,
  location: selectedLocation,
  duration_in_weeks: selectedNeedsMetric
}) : skipToken, [
  isReady,
  accountDetails?.account_id,
  selectedShape,
  selectedCaratRange,
  selectedColor,
  selectedClarity,
  selectedLocation,
  selectedNeedsMetric
]);

  // const [queryParams, setQueryParams] = useState({
  //   id: accountDetails.account_id,
  //   shape: selectedShape,
  //   carat_range: selectedCaratRange,
  //   color: selectedColor,
  //   clarity: selectedClarity,
  //   location: selectedLocation,
  //   duration_in_weeks: selectedNeedsMetric
  // });

  // Update query params when any dropdown value changes
  // useEffect(() => {
  //   setQueryParams({
  //     id: accountDetails.account_id,
  //     shape: selectedShape,
  //     carat_range: selectedCaratRange,
  //     color: selectedColor,
  //     clarity: selectedClarity,
  //     location: selectedLocation,
  //     duration_in_weeks: selectedNeedsMetric
  //   });
  // }, [selectedShape, selectedCaratRange, selectedNeedsMetric,selectedColor, selectedClarity,selectedLocation]);

  // Fetch data using the API query hook
  const { data, isLoading, isFetching } = useGetHigherLevelAnalysisMovementHistoryQuery(
    queryParams,
    {
      // Skip if any required param is missing
      // skip: !queryParams.color || !queryParams.clarity || !queryParams.shape || !queryParams.carat_range,
      // Refetch when parameters change
      refetchOnMountOrArgChange: true
    }
  );

  
    useEffect(() => {
      const summaryData = data?.data?.summary_data;
      if (summaryData && typeof summaryData === 'object') {
        setDiamondKeys(summaryData); // this now holds { price_change: 0.0, overhang: 2082, ... }
      }
    }, [data]);
     
  // Process chart data from API response
  const chartData = data?.data
    ? Object.entries(data.data.history_data).map(([week, values]) => ({
        week, // X-axis
        price_change: values.price_change,
        overhang: values.overhang,
        min_ppc: values.min_ppc,
        max_ppc: values.max_ppc,
        price_change_10th: values.price_change_10th,
        price_change_90th: values.price_change_90th,
      }))
    : [];

  // Handle dropdown change events
  const handleShapeChange = (event) => {
  dispatch(setSelectedShape(event.target.value));
  dispatch(setSelectedCell({
    shape: event.target.value,
    caratRange: selectedCaratRange,
  }));
};

const handleCaratRangeChange = (event) => {
  dispatch(setSelectedCaratRange(event.target.value));
  dispatch(setSelectedCell({
    shape: selectedShape,
    caratRange: event.target.value,
  }));
};

  const handleColorChange = (event) => {
    dispatch(setSelectedColors(event.target.value));
  };

  const handleClarityChange = (event) => {
    dispatch(setSelectedClarities(event.target.value));
  };

  // Find display name for the currently selected values
  const getDisplayName = (category, value) => {
    const option = tabOptionsConfig[category].options.find(opt => opt.value === value);
    return option ? option.display : '';
  };

  return (
    <div className="w-full flex flex-col">
      {/* Dropdowns row */}
      <div className="flex  justify-center items-center gap-4 mb-6 p-4  rounded-md">
        {/* Shape Dropdown */}
        <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
            <InputLabel>Shape</InputLabel>
                <Select
                value={selectedShape}
                label="Shape"
                onChange={handleShapeChange}
                >
                {tabOptionsConfig["Shape"].options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                    {option.display}
                    </MenuItem>
                ))}
                </Select>
        </FormControl>
        

     
        <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
            <InputLabel>Carat Range</InputLabel>
                <Select
                value={selectedCaratRange}
                onChange={handleCaratRangeChange}
                label="carat-select"
                >
                {tabOptionsConfig["Carat Range"].options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                    {option.display}
                    </MenuItem>
                ))}
                </Select>
         </FormControl>

      
        <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
            <InputLabel>Color</InputLabel>
                <Select
                    value={selectedColor}
                    onChange={handleColorChange}
                    label="color-select"
                    >
                    {tabOptionsConfig["Color"].options.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                        {option.display}
                        </MenuItem>
                    ))}
                </Select>
         </FormControl>

       
        <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
            <InputLabel>Clarity</InputLabel>
                <Select
                    value={selectedClarity}
                    onChange={handleClarityChange}
                    label="clarity-select"
                    >
                    {tabOptionsConfig["Clarity"].options.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.display}
                    </MenuItem>
                    ))}
                </Select>
         </FormControl>
      </div>

      
      <MISummaryCard diamondKeys={diamondKeys} />
      {/* Graph component */}
      <div className="w-full">
        <MIPriceMovementDataGraph
          isLoading={isLoading || isFetching}
          chartData={chartData}
          queryNParams={queryParams}
          shaperedux={selectedShape}
          caratRanges={selectedCaratRange}
        />
      </div>
    </div>
  );
};

export default MIFourDropGraph;